export default __webpack_public_path__ + "static/media/piadine.42835d25.png";